import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import {Button, Grid, IconButton, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getNodeInternalUrl} from "../../../constants/appRoutes";
import {nodeSelector} from "../../../state/node/nodeSelectors";
import {HEADER_BUTTON_VIEW_MODE_TEXT} from "../utils";

const NodeHomeButton = ({viewMode}) => {
  const {t} = useTranslation();
  const node = useSelector(nodeSelector);
  const navigate = useNavigate();
  return (
    <Grid className="node-home-btn">
      {viewMode === HEADER_BUTTON_VIEW_MODE_TEXT ? (
        <Button
          onClick={() => navigate(getNodeInternalUrl((node?.code || "").toLowerCase()))}
          aria-label={t("components.header.actions.nodeHome.ariaLabel")}
          sx={{color: theme => theme.palette.primary.contrastText}}
        >
          {t("components.header.actions.nodeHome.label")}
        </Button>
      ) : (
        <Tooltip title={t("components.header.actions.nodeHome.title")}>
          <IconButton
            color="inherit"
            onClick={() => navigate(getNodeInternalUrl((node?.code || "").toLowerCase()))}
            aria-label={t("components.header.actions.nodeHome.ariaLabel")}
          >
            <HomeIcon />
          </IconButton>
        </Tooltip>
      )}
    </Grid>
  );
};

export default NodeHomeButton;
